// extracted by mini-css-extract-plugin
export default {"wrapper":"SubtaskGroup_wrapper__8RMZW","header":"SubtaskGroup_header__J2QD9","name":"SubtaskGroup_name__KA4x5","body":"SubtaskGroup_body__e0pnS"};